interface Fraction {
  leadingNumber: number;
  numerator: number;
  denominator: number;
}

export const numberToFraction = (number: number, stepSize: number): Fraction => {
  const safeNumber = number + 0.001; // Fix slight rounding errors in JS
  return {
    leadingNumber: Math.floor(safeNumber),
    numerator: Math.round((safeNumber - Math.floor(safeNumber)) * stepSize),
    denominator: stepSize,
  };
};

export const roundToFraction = (number: number, stepSetting: number) => {
  const lower = Math.floor(number / stepSetting) * stepSetting;
  const upper = Math.ceil(number / stepSetting) * stepSetting;
  return Math.abs(upper - number) > Math.abs(number - lower) ? lower : upper;
};
